<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <div
    @keydown.esc="cancelModal"
    @click.self="cancelModal"
    class="modal fade"
    id="criar-user-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
  >
    <form @submit.prevent>
      <div class="modal-dialog" style="text-align: left">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Novo usuário admin</h4>
            <div class="form-group">
              <label for="email">Apelido</label>
              <input id="nome" type="text" class="form-control" v-model="formData.apelido" autocomplete="apelido" />

              <span style="color: red" v-for="error in v$.apelido.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>

            <div class="form-group">
              <label for="email">Email</label>
              <input id="email" type="email" class="form-control" v-model="formData.email" autocomplete="email" />

              <span style="color: red" v-for="error in v$.email.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>

            <div class="form-group">
              <label for="password">Senha</label>
              <div class="input-group mb-3">
                <input :type="show_pass ? 'text' : 'password'" class="form-control" v-model="formData.senha" />

                <div class="input-group-append">
                  <div
                    @click="show_pass = !show_pass"
                    class="input-group-text"
                    style="cursor: pointer; background-color: white; border-left: 0px solid #000000 !important"
                  >
                    <span id="lock" class="fas fa-eye"></span>
                  </div>
                </div>
              </div>

              <span style="color: red" v-for="error in v$.senha.$errors" :key="error.$uid">
                {{ error.$message }}
              </span>
            </div>

            <button @click="update()" class="btn btn-primary btn-sm">Salvar</button>

            <button
              id="close_create_user"
              style="margin-left: 5px"
              class="btn btn-danger btn-sm"
              data-toggle="modal"
              data-target="#criar-user-modal"
              @click="setCriarUsuario(false)"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { helpers } from "@vuelidate/validators";
import useVueLidate from "@vuelidate/core";
import { required, minLength } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  components: { Loading },

  props: ["setCriarUsuario", "usuarioCriado"],

  data() {
    return {
      nome: "",
      email: "",
      isLoading: false,
      my_container: {},
      show_pass: false,
    };
  },

  setup() {
    const formData = reactive({
      apelido: "",
      email: "",
      senha: "",
    });

    const rules = computed(() => {
      return {
        apelido: { required, minLength: minLength(5) },
        email: { required, validarEmail: helpers.withMessage(' A senha deve incluir um "@".', validarEmail) },
        senha: { required, minLength: minLength(5) },
      };
    });

    const validarEmail = (value) => {
      if (value && value.includes("@")) {
        return true;
      } else {
        if (!value) {
          return true;
        }
        return false;
      }
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {},

  methods: {
    cancelModal() {
      this.setCriarUsuario(false);
    },

    async update() {
      const result = await this.v$.$validate();

      if (result) {
        this.isLoading = true;

        let data = {
          apelido: this.formData.apelido,
          senha: this.formData.senha,
          email: this.formData.email,
        };

        console.log("Criando agora");
        console.log(data);

        axios
          .post(`/admin/usuarios_admin/store`, data)
          .then((response) => {
            this.isLoading = false;
            if (response.data.success) {
              this.showSuccessMessage("Usuário criado!");
              this.usuarioCriado();
            } else {
              this.showErrorMessageWithButton("Ops...", response.data.msg);
            }
          })
          .catch((error) => {
            this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
            console.log(error.response.data);
          });
      }
    },
  },
};
</script>

<style scoped>
.swal-modal {
  color: green;
  background-color: rgba(63, 255, 106, 0.69);
  border: 3px solid white;
}

.swal-overlay {
  background-color: rgba(43, 165, 137, 0.45);
}
</style>
